function NoPhotos({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.5999 19.9L15.4999 13.8L12.8099 11.11L4.69989 2.99998L3.28989 1.58998L1.79989 0.0999756L0.389893 1.50998L2.69989 3.82998V17C2.69989 18.1 3.59989 19 4.69989 19H17.8699L20.1799 21.31L21.5999 19.9ZM4.69989 17V5.82998L11.5399 12.67L10.6999 13.72L8.69989 11L5.69989 15H13.8699L15.8699 17H4.69989ZM7.52989 2.99998L5.52989 0.999976H18.6999C19.7999 0.999976 20.6999 1.89998 20.6999 2.99998V16.17L18.6999 14.17V2.99998H7.52989Z" fill=${`"${col}"`}/>
    </svg>
  `;
  return baseXml;
}

export default NoPhotos;
